module.exports = __webpack_public_path__ + "img/folder.2fa0854b.svg";